<div class="menu-wrapper" [ngClass]="{'layout-sidebar-active': sidebarActive}"
    (click)="onSidebarClick($event)" (mouseover)="onSidebarMouseOver($event)" (mouseleave)="onSidebarMouseLeave($event)" >
    <div class="sidebar-logo">
        <a>
            
        </a>
        <a href="#" class="sidebar-pin" (click)="onToggleMenu($event)">
            <span class="pin"></span>
        </a>
    </div>
    <div class="layout-menu-container" *ngIf="isLoader" >
        <ul class="layout-menu">
            <li class="layout-item" app-menuitem *ngFor="let item of items; let i = index;" [item]="item" [index]="i" [root]="true" [appMain]="appMain" ></li>
        </ul>
    </div>
</div>
